var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediaPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.6812 83.265C42.3479 84.0359 40.6802 83.0737 40.6802 81.5336V51.4664C40.6802 49.9263 42.3478 48.9641 43.6812 49.735L69.6852 64.7685C71.0172 65.5386 71.0172 67.4614 69.6852 68.2315L43.6812 83.265Z",
    fill: "#E9AF34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.2 30.45H81.7603V10L102.2 30.45Z",
    fill: "#E9AF34"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.2 30.45H81.7603V10L102.2 30.45Z",
    stroke: "#CDD9E2",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9613 74.3482L70.6802 134.712L131.044 139.993L136.325 79.6294L75.9613 74.3482Z",
    fill: "#DB6C2F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9613 74.3482L70.6802 134.712L131.044 139.993L136.325 79.6294L75.9613 74.3482Z",
    stroke: "#B4C5D0",
    strokeWidth: 0.450781,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M119.326 122.202L85.3011 119.227L100.537 101.854L107.2 111.861L110.978 107.904L119.326 122.202Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.450781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M121.769 98.0316C121.704 98.798 121.412 99.5277 120.932 100.128C120.451 100.729 119.803 101.173 119.07 101.405C118.336 101.637 117.551 101.646 116.812 101.432C116.074 101.217 115.415 100.787 114.921 100.198C114.427 99.6089 114.118 98.8862 114.035 98.1216C113.951 97.3569 114.097 96.5847 114.453 95.9028C114.809 95.2209 115.359 94.6599 116.034 94.291C116.709 93.922 117.478 93.7617 118.244 93.8303C119.268 93.922 120.214 94.4155 120.874 95.2029C121.535 95.9903 121.857 97.0075 121.769 98.0316V98.0316Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.450781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.73 120.76H18.68C17.9337 120.761 17.1945 120.615 16.5048 120.33C15.8151 120.045 15.1884 119.627 14.6607 119.099C14.133 118.572 13.7147 117.945 13.4297 117.255C13.1447 116.565 12.9987 115.826 13 115.08V17.38C13 15.8736 13.5984 14.4288 14.6636 13.3636C15.7288 12.2984 17.1736 11.7 18.68 11.7H82.28",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3604 28.74V70.75",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaPhoto);
export default __webpack_public_path__ + "static/media/media_photo.59f8aad5fc0a719235ee4d3e8012a0e4.svg";
export { ForwardRef as ReactComponent };